import excludeParams from '#frontend/singleDataLayer/utils/excludeParams.js';

/**
 * Shared screen object
 * @param {object} cart
 * @returns {object} screen object
 */
export default (cart) => ({
	screen: {
		location: {
			url: excludeParams.fromUrl(cart.url.href),
			woParams: cart.url.hostname + cart.url.pathname,
			protocol: cart.url.protocol,
			path: cart.url.pathname,
			hostname: cart.url.hostname,
			hash: cart.url.hash,
			params: excludeParams.fromArray(cart.url.query) // @todo: Need to be resolved with OMS flow
		},
		locale: cart.url.locale,
		screenCategory: `cart-${cart.url.theme}`,
		title: cart.page.tracking,
		lineOfBusiness: cart.order ? cart.order.contentGroup.toLowerCase() : ''
	},
	event: 'screen'
});
